var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowChartArrowMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 59,
    viewBox: "0 0 178 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 59,
    rx: 29.5,
    fill: "url(#paint0_linear_7797_23372)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7797_23372",
    x1: 22.5,
    y1: 56,
    x2: 174.052,
    y2: 18.2969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78B63B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169285,
    stopColor: "#97D758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#A1E161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696344,
    stopColor: "#9ADA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#72AF35"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowChartArrowMobile);
export default __webpack_public_path__ + "static/media/flow_chart_arrow_mobile.290ee7abae7ef94cf6844ca014bcf65c.svg";
export { ForwardRef as ReactComponent };